export { default } from './FareSimpleSorting';
